import { Component, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";
import { MANAGER_ROLES } from "src/app/core/constants";
import { RunningUserContext } from "src/app/core/models/running-user-context.model";
import { UpdateSessionBody } from "src/app/core/models/update-session.model";
import { AppConfigurationService } from "src/app/core/services/app-configuration.service";
import { LoginService } from "src/app/core/services/login.service";
import { LogoutService } from "src/app/core/services/logout.service";
import { UpdateSessionService } from "src/app/core/services/update-session.service";
import { BrowserStorageService } from "src/app/core/utilities/browser-storage.utility";
import { fromRoot } from "src/app/core/utilities/ngrx-loader.utility";

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    standalone: false
})
export class ErrorPageComponent implements OnDestroy {

  slbLogo: string;
  runningUserContext!: RunningUserContext;
  updateSessionBody!: UpdateSessionBody;
  managerRoles = MANAGER_ROLES;

  subscriptionsToCancel: Subscription = new Subscription();


  constructor(
    private readonly loginService: LoginService,
    private readonly appConfigurationService: AppConfigurationService,
    private readonly logoutService: LogoutService,
    private readonly sessionStorage: BrowserStorageService,
    private readonly sessionService: UpdateSessionService,
    private readonly loaderStore: Store<{ loader: number }>,
    private readonly router: Router,
  ) {
    this.slbLogo = this.appConfigurationService.configuration.imagePathsConfiguration.slbLogo;
  }

  ngOnDestroy(): void {
    this.subscriptionsToCancel.unsubscribe();
  }

  logout() {
    this.loaderStore.dispatch(fromRoot.addLoader()());
    this.logoutService.deleteSession().subscribe((resp) => {
      this.loginService.clearStorage();
    });
    this.loginService.logoff();
  }

  onContextChanges(defaultContext: any) {
    this.runningUserContext = this.sessionStorage.get(BrowserStorageService.runningUserContextKey)

    if (this.runningUserContext.account.accountId !== defaultContext.crmAccountId || this.runningUserContext.contract.contractId !== defaultContext.crmContractId || this.runningUserContext.department.departmentId !== defaultContext.departmentId) {
      this.updateSessionBody = new UpdateSessionBody();
      this.subscriptionsToCancel.add(this.sessionService.updateSession(this.updateSessionBody).subscribe({
        next: (response) => {
          this.runningUserContext = {
            account: { accountId: defaultContext.crmAccountId, name: defaultContext.accountName, internal: this.runningUserContext.account.internal },
            contract: { contractId: defaultContext.crmContractId },
            department: { departmentId: defaultContext.departmentId, name: defaultContext.departmentName }
          }
          this.sessionStorage.set(BrowserStorageService.runningUserContextKey, this.runningUserContext)
          setTimeout(() => {
            this.windowReload();
          }, 1000);
        },
        error: (err: any) => {
          this.logoutService.deleteSession().subscribe((resp) => {
            this.loginService.clearStorage();
          });
          this.loginService.logoff()
        }
      }));
    } else if (defaultContext.crmAccountId && defaultContext.crmContractId && defaultContext.departmentId) {
      this.router.navigate(['home']);
    }
  }

  windowReload() {
    window.location.reload()
  }

}